<template>
  <div id="excel-finiquito">
    <custom-button
      label="Finiquito"
      iconText="fa-file-excel"
      tipo="agregar"
      class="mr-2"
      :loading="estaCargando"
      @click="generarExcelFiniquito"
    >
    </custom-button>
  </div>
</template>

<script>
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import CustomButton from '@/components/buttons/Button.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 16;
const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 2;

export default {
  name: 'ExcelFiniquito',
  mixins: [mixGenerarExceles],
  props: {
    catalogoConceptos: {
      type: Array,
      required: true,
    },
    estimaciones: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    firmas: {
      type: Array,
      required: false,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      catalogo: this.catalogoConceptos,
      estaCargando: false,
      nombreDocumento: 'FINIQUITO',
      configuracionExcel: {
        estilosTablas: [],
        anchoColumnas: [
          {
            columna: 2,
            size: 40,
          },
          {
            columna: 3,
            size: 22,
          },
          {
            columna: 4,
            to: 17,
            size: 15,
          },
        ],
        altoFilas: [
          { fila: 1, size: 88 },
          { fila: 3, size: 41 },
          { fila: 4, size: 35 },
          { fila: 5, size: 28 },
          { fila: 8, size: 55 },
          { fila: 9, size: 66 },
          { fila: 13, size: 45 },
          { fila: 14, size: 38 },
        ],
      },
      filaTitulos: 2,
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        border: {
          top: {
            style: 'medium',
            color: '000000',
          },
          bottom: {
            style: 'medium',
            color: '000000',
          },
          left: {
            style: 'medium',
            color: '000000',
          },
          right: {
            style: 'medium',
            color: '000000',
          },
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
        },
      },
      estiloBody: {
        border: {
          top: {
            style: 'thin',
            color: '000000',
          },
          bottom: {
            style: 'thin',
            color: '000000',
          },
          left: {
            style: 'thin',
            color: '000000',
          },
          right: {
            style: 'thin',
            color: '000000',
          },
        },
      },
      logoDocumento: [
        {
          // este path de la imagen del logo corresponde a la ruta en el servidor de la API
          path: 'public/img/logos/logohayuntamiento.png',
          type: 'picture',
          position: {
            type: 'twoCellAnchor',
            from: {
              col: 1,
              colOff: '3cm',
              row: 1,
              rowOff: '2mm',
            },
            to: {
              col: 2,
              colOff: '7cm',
              row: 1,
              rowOff: '25mm',
            },
          },
        },
        {
          // este path de la imagen del logo corresponde a la ruta en el servidor de la API
          path: 'public/img/logos/escudo.png',
          type: 'picture',
          position: {
            type: 'twoCellAnchor',
            from: {
              col: 16,
              colOff: '2cm',
              row: 1,
              rowOff: '2mm',
            },
            to: {
              col: 17,
              colOff: '2cm',
              row: 1,
              rowOff: '4cm',
            },
          },
        },
      ],
      // Datos de los encabezados que apareceran en el excel.
      headers: [
        {
          value: 'CLAVE', combinar: { row: filaSubtitulos, col: 1 },
        },
        {
          value: 'CONCEPTO', combinar: { row: filaSubtitulos, col: 3 },
        },
        {
          value: 'SEGÚN PRESUPUESTO',
          row: filaTitulos,
          col: 4,
          combinar: {
            row: filaTitulos,
            col: 7,
          },
        },
        {
          value: '',
          row: filaSubtitulos,
        },
        {
          value: 'UNIDAD',
          row: filaSubtitulos,
        },
        {
          value: 'CANTIDAD',
          row: filaSubtitulos,
        },
        {
          value: 'P. U.',
          row: filaSubtitulos,
          estilo: {
            font: {
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: 'IMPORTE',
          row: filaSubtitulos,
        },
      ],
      // Datos de las columnas que aparecerán en el excel.
      columnas: [
        'clave',
        'concepto',
        '',
        'unidad',
        'cantidad',
        'precioUnitarioMon',
        'importeMon',
      ],
    };
  },
  methods: {
    async generarExcelFiniquito() {
      const data = this.crearExcelFiniquito;
      await this.mixGenerarExcel(data);
    },
    setAltoFila(fila) {
      this.configuracionExcel.altoFilas.push({
        fila: fila.numero,
        size: fila.size,
      });
    },
    setAltoDeFilas(catalogoParaExcel) {
      let filaActual = filaInicioDatos;
      catalogoParaExcel.forEach((concepto) => {
        if (concepto.tipo === 0 || !concepto.tipo) filaActual += 1;
        if (concepto.tipo === 1 || concepto.tipo === 2) {
          this.configuracionExcel.altoFilas.push({ fila: filaActual, size: 65 });
          filaActual += 1;
        }
      });
    },
    getFechaTexto(fecha) {
      if (!fecha) {
        return new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
      }
      return new Date(`${fecha}T00:00:00`).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
    },
    setEstiloGlobalTabla(filasColumnasEstilo) {
      this.configuracionExcel.estilosTablas.push(
        {
          filaInicial: filasColumnasEstilo.filaInicial,
          filaFinal: filasColumnasEstilo.filaFinal,
          columnaInicial: filasColumnasEstilo.columnaInicial,
          columnaFinal: filasColumnasEstilo.columnaFinal,
          estilo: filasColumnasEstilo.estilo,
        },
      );
    },
  },
  computed: {
    // getSupervisor() {
    //   if (!this.contrato) return null;
    //   if (!this.contrato.responsables) return null;
    //   return this.contrato.responsables.find((responsable) => responsable.principal === true);
    // },
    getRepresentanteLegal() {
      if (!this.contrato.contratista.nombreRepresentante) return '';
      return this.contrato.contratista.nombreRepresentante;
    },
    getNombreEmpresa() {
      if (!this.contrato.contratista.nombreRazonSocial) return '';
      return this.contrato.contratista.nombreRazonSocial;
    },
    getContratoSupervisionExterna() {
      if (this.contrato.contratosRelacionados.length <= 0) return null;
      const contratoSupervisionExterna = this.contrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
      if (!contratoSupervisionExterna) return null;
      return contratoSupervisionExterna.contratoRelacionado.contratista.nombreRazonSocial;
    },
    getFirmasOrdenado() {
      if (!this.firmas) return [];
      return this.firmas.slice().sort((a, b) => a.orden - b.orden)
        .map((firma) => ({
          nombre: firma.funcionario.nombre,
          subNombre: firma.funcionario.puesto.toUpperCase(),
        }));
    },
    getSupervisor() {
      if (this.contrato.responsables.length === 0) return '';
      const supervisor = this.contrato.responsables
        .find((responsable) => responsable.principal === true);
      const { nombre } = supervisor.funcionario;
      return nombre;
    },
    getSuperintendente() {
      if (this.contrato.superintendentes.length === 0) return '';
      const superintendente = this.contrato.superintendentes[0];
      const { nombreCompleto } = superintendente;
      return nombreCompleto;
    },
    getContratoFianza() {
      if (!this.contrato.fianzas) {
        return {
          nombreAfianzadora: '[NOMBRE AFIANZADORA]',
          fecha: '[FECHA FIANZA]',
          numero: '[NUMERO FIANZA]',
        };
      }
      const fianzaViciosOcultos = this.contrato.fianzas.find((fianza) => fianza.tipo === 3);
      if (!fianzaViciosOcultos) {
        return {
          nombreAfianzadora: '[NOMBRE AFIANZADORA]',
          fecha: '[FECHA FIANZA]',
          numero: '[NUMERO FIANZA]',
        };
      }
      return {
        nombreAfianzadora: fianzaViciosOcultos.nombreAfianzadora,
        fecha: this.getFechaTexto(fianzaViciosOcultos.fecha),
        numero: fianzaViciosOcultos.numero,
      };
    },
    crearHeaders() {
      const { headers } = this;
      let celdaCombinacion = 7;
      let celdaInicio = 8;
      // Agregar headers para las estimaciones y columna de totales al final.
      for (let i = 0; i < this.estimaciones.length; i += 1) {
        celdaCombinacion += 2;
        headers.push({
          value: `ESTIMACIÓN ${i + 1}`,
          col: celdaInicio,
          combinar: {
            row: filaTitulos,
            col: celdaCombinacion,
          },
        },
        {
          value: 'CANTIDAD',
          row: filaSubtitulos,
        },
        {
          value: 'IMPORTE',
          row: filaSubtitulos,
        });
        celdaInicio += 2;
      }
      // Agregar columna de totales
      celdaCombinacion += 2;
      headers.push(
        { value: 'ACUMULADO', col: celdaInicio, combinar: { row: filaTitulos, col: celdaCombinacion } },
        { value: 'VOLUMEN', row: filaSubtitulos },
        { value: 'IMPORTE', row: filaSubtitulos },
        { value: 'DIFERENCIA', col: celdaInicio + 2, combinar: { row: filaTitulos, col: celdaCombinacion + 2 } },
        { value: 'VOLUMEN', row: filaSubtitulos },
        { value: 'IMPORTE', row: filaSubtitulos },
      );
      return headers;
    },
    // Se mapea el catalogo para romper la referencia a la propiedad recibida en props
    // y evitar mutar el catalogo de conceptos original.
    // (fue la única manera de crear una copia y romper la referencia al original)
    setCatalogoPadrePrincipal() {
      const catalogoConIdPadrePrincipal = [];
      const partidas = this.catalogoConceptos.filter((concepto) => concepto.tipo === 0);
      partidas.forEach((partida) => {
        catalogoConIdPadrePrincipal.push({
          ...partida,
          idPadrePrincipal: '',
        });
        // Primer Nivel
        const hijosNivel1 = this.catalogoConceptos
          .filter((concepto) => concepto.idPadre === partida.id);
        hijosNivel1.forEach((hijoNivel1) => {
          if (hijoNivel1.tipo === 2) {
            catalogoConIdPadrePrincipal.push({
              ...hijoNivel1,
              idPadrePrincipal: partida.id,
            });
          }
          if (hijoNivel1.tipo === 1) {
            catalogoConIdPadrePrincipal.push({
              ...hijoNivel1,
              idPadrePrincipal: partida.id,
            });
            // Segundo Nivel
            const hijosNivel2 = this.catalogoConceptos
              .filter((concepto) => concepto.idPadre === hijoNivel1.id);
            hijosNivel2.forEach((hijoNivel2) => {
              if (hijoNivel2.tipo === 2) {
                catalogoConIdPadrePrincipal.push({
                  ...hijoNivel2,
                  idPadrePrincipal: partida.id,
                });
              }
              if (hijoNivel2.tipo === 1) {
                catalogoConIdPadrePrincipal.push({
                  ...hijoNivel2,
                  idPadrePrincipal: partida.id,
                });
                // Tercer Nivel
                const hijosNivel3 = this.catalogoConceptos
                  .filter((concepto) => concepto.idPadre === hijoNivel2.id);
                hijosNivel3.forEach((hijoNivel3) => {
                  if (hijoNivel3.tipo === 2) {
                    catalogoConIdPadrePrincipal.push({
                      ...hijoNivel3,
                      idPadrePrincipal: partida.id,
                    });
                  }
                  if (hijoNivel3.tipo === 1) {
                    catalogoConIdPadrePrincipal.push({
                      ...hijoNivel3,
                      idPadrePrincipal: partida.id,
                    });
                    // Cuarto Nivel
                    const hijosNivel4 = this.catalogoConceptos
                      .filter((concepto) => concepto.idPadre === hijoNivel3.id);
                    hijosNivel4.forEach((hijoNivel4) => {
                      if (hijoNivel4.tipo === 2) {
                        catalogoConIdPadrePrincipal.push({
                          ...hijoNivel4,
                          idPadrePrincipal: partida.id,
                        });
                      }
                      if (hijoNivel4.tipo === 1) {
                        catalogoConIdPadrePrincipal.push({
                          ...hijoNivel4,
                          idPadrePrincipal: partida.id,
                        });
                        // Quinto Nivel
                        const hijosNivel5 = this.catalogoConceptos
                          .filter((concepto) => concepto.idPadre === hijoNivel4.id);
                        hijosNivel5.forEach((hijoNivel5) => {
                          if (hijoNivel5.tipo === 2) {
                            catalogoConIdPadrePrincipal.push({
                              ...hijoNivel5,
                              idPadrePrincipal: partida.id,
                            });
                          }
                          if (hijoNivel5.tipo === 1) {
                            catalogoConIdPadrePrincipal.push({
                              ...hijoNivel5,
                              idPadrePrincipal: partida.id,
                            });
                            // Sexto Nivel
                            const hijosNivel6 = this.catalogoConceptos
                              .filter((concepto) => concepto.idPadre === hijoNivel5.id);
                            hijosNivel6.forEach((hijoNivel6) => {
                              if (hijoNivel6.tipo === 2) {
                                catalogoConIdPadrePrincipal.push({
                                  ...hijoNivel6,
                                  idPadrePrincipal: partida.id,
                                });
                              }
                            });
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      });
      return catalogoConIdPadrePrincipal;
    },
    getEstimaciones() {
      return this.estimaciones.map((estimacion) => ({
        ...estimacion,
      }));
    },
    getImporteAnticipoContrato() {
      if (!this.contrato.anticipos) {
        return {
          importe: 0,
        };
      }
      const anticipoContrato = this.$ObjSumar(this.contrato.anticipos, 'importe');
      return {
        importe: anticipoContrato,
      };
    },
    getAnticiposEstimaciones() {
      const anticipos = this.getEstimaciones.slice()
        .map((estimacion) => ({
          numEstimacion: estimacion.numero,
          importe: this.contrato.esObraFinanciada
            ? estimacion.importeAmortizacionAnticipo
            + estimacion.importeCostoFinancieroAmortizacionAnticipo
            : estimacion.importeAmortizacionAnticipo,
        }));
      return anticipos;
    },
    crearCatalogoParaExcel() {
      const catalogoParaExcel = this.setCatalogoPadrePrincipal.slice()
        .map((concepto) => {
          const nuevoConcepto = concepto;
          const estimado = concepto.estimado
            .sort((a, b) => (a.estimacion.numero - b.estimacion.numero));
          estimado.forEach((estimacion) => {
            nuevoConcepto[`cantidadEstimada${estimacion.estimacion.numero}`] = estimacion.cantidad;
            nuevoConcepto[`importeEstim${estimacion.estimacion.numero}`] = estimacion.importe;
            nuevoConcepto[`importeEstimado${estimacion.estimacion.numero}`] = {
              value: estimacion.importe,
              estilo: {
                border: {
                  top: {
                    style: 'thin',
                    color: '000000',
                  },
                  bottom: {
                    style: 'thin',
                    color: '000000',
                  },
                  left: {
                    style: 'thin',
                    color: '000000',
                  },
                  right: {
                    style: 'thin',
                    color: '000000',
                  },
                },
                numberFormat: '#,##0.00',
              },
            };
          });
          if (concepto.tipo === 0) {
            nuevoConcepto.concepto = {
              value: concepto.concepto,
              estilo: {
                font: {
                  size: 12,
                  bold: true,
                },
                border: {
                  top: {
                    style: 'thin',
                    color: '000000',
                  },
                  bottom: {
                    style: 'thin',
                    color: '000000',
                  },
                  left: {
                    style: 'thin',
                    color: '000000',
                  },
                  right: {
                    style: 'thin',
                    color: '000000',
                  },
                },
                alignment: {
                  horizontal: 'center',
                  vertical: 'center',
                },
              },
              combinar: {
                col: 3,
              },
            };
          }
          if (concepto.tipo === 1 || concepto.tipo === 2) {
            nuevoConcepto.concepto = {
              value: concepto.concepto,
              estilo: {
                font: {
                  size: 12,
                  bold: false,
                },
                border: {
                  top: {
                    style: 'thin',
                    color: '000000',
                  },
                  bottom: {
                    style: 'thin',
                    color: '000000',
                  },
                  left: {
                    style: 'thin',
                    color: '000000',
                  },
                  right: {
                    style: 'thin',
                    color: '000000',
                  },
                },
                alignment: {
                  horizontal: 'left',
                  vertical: 'center',
                  wrapText: true,
                },
              },
              combinar: {
                col: 3,
              },
            };
          }
          return nuevoConcepto;
        }).map((concepto) => {
          const nuevoConcepto = concepto;
          nuevoConcepto.precioUnitarioMon = {
            value: concepto.precioUnitario,
            estilo: {
              border: {
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
              numberFormat: '#,##0.00',
            },
          };
          nuevoConcepto.importeMon = {
            value: concepto.importe,
            estilo: {
              border: {
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
              numberFormat: '#,##0.00',
            },
          };
          return nuevoConcepto;
        }).map((concepto) => {
          const nuevoConcepto = concepto;
          nuevoConcepto.unidad = {
            value: concepto.unidad,
            estilo: {
              border: {
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
              alignment: {
                horizontal: 'center',
                vertical: 'bottom',
              },
            },
          };
          return nuevoConcepto;
        })
        .map((concepto) => {
          const totalCantidad = concepto.estimado
            .reduce((valorPrevio, { cantidad }) => valorPrevio + cantidad, 0);
          const totalImporte = concepto.estimado
            .reduce((valorPrevio, { importe }) => valorPrevio + importe, 0);
          const diferenciaCantidad = concepto.cantidad - totalCantidad;
          const diferenciaImporte = concepto.importe - totalImporte;
          return {
            ...concepto,
            importeTotal: totalImporte,
            totalCantidad,
            totalImporte: {
              value: totalImporte,
              estilo: {
                border: {
                  top: {
                    style: 'thin',
                    color: '000000',
                  },
                  bottom: {
                    style: 'thin',
                    color: '000000',
                  },
                  left: {
                    style: 'thin',
                    color: '000000',
                  },
                  right: {
                    style: 'thin',
                    color: '000000',
                  },
                },
                numberFormat: '#,##0.00',
              },
            },
            diferenciaCantidad,
            diferenciaImporte: {
              value: diferenciaImporte,
              estilo: {
                border: {
                  top: {
                    style: 'thin',
                    color: '000000',
                  },
                  bottom: {
                    style: 'thin',
                    color: '000000',
                  },
                  left: {
                    style: 'thin',
                    color: '000000',
                  },
                  right: {
                    style: 'thin',
                    color: '000000',
                  },
                },
                numberFormat: '#,##0.00',
              },
            },
          };
        })
        .sort((a, b) => a.orden - b.orden);
      return catalogoParaExcel;
    },
    getResumenPartidas() {
      const resumenPartidas = this.crearCatalogoParaExcel
        .filter((partida) => partida.tipo === 0)
        .map((partida) => ({
          id: partida.id,
          nombre: partida.concepto.value,
          conceptos: this.crearCatalogoParaExcel
            .filter((concepto) => concepto.tipo === 2 && concepto.idPadrePrincipal === partida.id),
        }))
        .map((partida) => ({
          ...partida,
          totalImportesPresupuesto: this.$ObjSumar(partida.conceptos, 'importe'),
          totalImportesAcumulados: this.$ObjSumar(partida.conceptos, 'importeTotal'),
        }))
        .map((partida) => ({
          ...partida,
          totalImportesAcumuladosMenosImportesPresupuesto: partida.totalImportesPresupuesto
          - partida.totalImportesAcumulados,
        }));
      return resumenPartidas;
    },
    getTotalImportesConceptosPorEstimacion() {
      const TotalImportesConceptosPorEstimacion = [];
      const numEstimaciones = this.estimaciones.length;
      const conceptosEstimados = this.catalogoConSubtotalesExcel
        .filter((concepto) => concepto.tipo === 2);
      for (let i = 1; i <= numEstimaciones; i += 1) {
        TotalImportesConceptosPorEstimacion.push({
          estimacion: i,
          importeTotalConceptos: this.$ObjSumar(conceptosEstimados, `importeEstim${i}`),
        });
      }
      return TotalImportesConceptosPorEstimacion
        .sort((a, b) => a.numero - b.numero);
    },
    catalogoConSubtotalesExcel() {
      const catalogoConSubtotalesExcel = [];
      let idPadre = null;
      this.crearCatalogoParaExcel.forEach((concepto) => {
        if (idPadre && concepto.tipo === 2) {
          catalogoConSubtotalesExcel.push(concepto);
        }
        if (idPadre && concepto.tipo === 1) {
          catalogoConSubtotalesExcel.push({
            clave: {
              value: concepto.clave,
              col: 1,
              estilo: {
                font: {
                  size: 12,
                  bold: true,
                },
              },
            },
            concepto: {
              value: concepto.concepto.value,
              col: 2,
              estilo: {
                font: {
                  size: 12,
                  bold: true,
                },
              },
              combinar: {
                col: 3,
              },
            },
          });
        }
        if (idPadre && concepto.tipo === 0) {
          catalogoConSubtotalesExcel.push({
            concepto: {
              value: `SUBTOTAL: ${this.getResumenPartidas.find((partida) => partida.id === idPadre).nombre}`,
              col: 4,
              estilo: {
                font: {
                  size: 12,
                  bold: true,
                },
                alignment: {
                  horizontal: 'right',
                  vertical: 'bottom',
                  wrapText: true,
                },
              },
              combinar: {
                col: 6,
              },
            },
            importeMon: {
              value: this.getResumenPartidas
                .find((partida) => partida.id === idPadre).totalImportesPresupuesto,
              estilo: {
                font: {
                  size: 12,
                  bold: true,
                },
                border: {
                  top: {
                    style: 'medium',
                    color: '000000',
                  },
                  bottom: {
                    style: 'medium',
                    color: '000000',
                  },
                  left: {
                    style: 'medium',
                    color: '000000',
                  },
                  right: {
                    style: 'medium',
                    color: '000000',
                  },
                },
                numberFormat: '#,##0.00',
              },
            },
            totalImporte: {
              value: this.getResumenPartidas
                .find((partida) => partida.id === idPadre).totalImportesAcumulados,
              estilo: {
                font: {
                  size: 12,
                  bold: true,
                },
                border: {
                  top: {
                    style: 'medium',
                    color: '000000',
                  },
                  bottom: {
                    style: 'medium',
                    color: '000000',
                  },
                  left: {
                    style: 'medium',
                    color: '000000',
                  },
                  right: {
                    style: 'medium',
                    color: '000000',
                  },
                },
                numberFormat: '#,##0.00',
              },
            },
          });
          catalogoConSubtotalesExcel.push({
            concepto: concepto.concepto,
          });
          idPadre = concepto.id;
        }
        if (!idPadre && concepto.tipo === 0) {
          idPadre = concepto.id;
          catalogoConSubtotalesExcel.push({
            concepto: concepto.concepto,
          });
        }
      });
      catalogoConSubtotalesExcel.push({
        concepto: {
          value: `SUBTOTAL: ${this.getResumenPartidas.find((partida) => partida.id === idPadre).nombre}`,
          col: 4,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            col: 6,
          },
        },
        importeMon: {
          value: this.getResumenPartidas
            .find((partida) => partida.id === idPadre).totalImportesPresupuesto,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            numberFormat: '#,##0.00',
          },
        },
        totalImporte: {
          value: this.getResumenPartidas
            .find((partida) => partida.id === idPadre).totalImportesAcumulados,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            numberFormat: '#,##0.00',
          },
        },

      });
      return catalogoConSubtotalesExcel;
    },
    crearTablaResumenEstimaciones() {
      const tablaResumenEstimaciones = [];
      const inicioTablaResumenEstimaciones = filaInicioDatos
      + this.catalogoConSubtotalesExcel.length + 2;
      const columnaInicioTabla = 2;
      let columnaInicioEstimaciones = 8;
      tablaResumenEstimaciones.push(
        {
          value: 'IMPORTE DE CONTRATO',
          row: inicioTablaResumenEstimaciones,
          col: columnaInicioTabla,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: inicioTablaResumenEstimaciones,
            col: columnaInicioTabla + 1,
          },
        },
        {
          value: this.contrato.importe,
          row: inicioTablaResumenEstimaciones,
          col: columnaInicioTabla + 2,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            numberFormat: '#,##0.00',

          },
          combinar: {
            row: inicioTablaResumenEstimaciones,
            col: columnaInicioTabla + 5,
          },
        },
      );
      this.getTotalImportesConceptosPorEstimacion
        .forEach((estimacion) => {
          tablaResumenEstimaciones.push(
            {
              value: `EST. ${estimacion.estimacion}`,
              row: inicioTablaResumenEstimaciones,
              col: columnaInicioEstimaciones,
              estilo: {
                font: {
                  size: 12,
                  bold: true,
                },
                border: {
                  top: {
                    style: 'medium',
                    color: '000000',
                  },
                  bottom: {
                    style: 'medium',
                    color: '000000',
                  },
                  left: {
                    style: 'medium',
                    color: '000000',
                  },
                  right: {
                    style: 'medium',
                    color: '000000',
                  },
                },
                alignment: {
                  horizontal: 'center',
                  vertical: 'center',
                  wrapText: true,
                },
              },
            },
            {
              value: estimacion.importeTotalConceptos,
              row: inicioTablaResumenEstimaciones,
              col: columnaInicioEstimaciones + 1,
              estilo: {
                font: {
                  size: 12,
                  bold: true,
                },
                border: {
                  top: {
                    style: 'medium',
                    color: '000000',
                  },
                  bottom: {
                    style: 'medium',
                    color: '000000',
                  },
                  left: {
                    style: 'medium',
                    color: '000000',
                  },
                  right: {
                    style: 'medium',
                    color: '000000',
                  },
                },
                alignment: {
                  horizontal: 'center',
                  vertical: 'center',
                  wrapText: true,
                },
                numberFormat: '#,##0.00',

              },
            },
          );
          columnaInicioEstimaciones += 2;
        });
      tablaResumenEstimaciones.push(
        {
          value: 'SUMA',
          row: inicioTablaResumenEstimaciones,
          col: columnaInicioEstimaciones,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: this.$ObjSumar(this.getTotalImportesConceptosPorEstimacion, 'importeTotalConceptos'),
          row: inicioTablaResumenEstimaciones,
          col: columnaInicioEstimaciones + 1,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            numberFormat: '#,##0.00',

          },
        },
      );
      return tablaResumenEstimaciones;
    },
    crearTablaResumenPartidas() {
      const inicioTablaResumenPartidas = filaInicioDatos
      + this.catalogoConSubtotalesExcel.length + 10;
      let filaDatosTabla = inicioTablaResumenPartidas + 1;
      let columnaTitulos = 2;
      const columnaDatosTabla = 2;
      const titulosTablaResumenPartidas = [
        'PARTIDA',
        'PARTIDAS PRESUPUESTADA',
        'PARTIDA EJERCIDA',
        'PARTIDA POR EJERCER',
      ];
      const tablaResumenPartidas = [];
      // Crear los titulos de la tabla.
      this.setAltoFila({ numero: inicioTablaResumenPartidas, size: 31 });
      titulosTablaResumenPartidas.forEach((titulo) => {
        tablaResumenPartidas.push(
          {
            value: titulo,
            row: inicioTablaResumenPartidas,
            col: columnaTitulos,
            estilo: {
              font: {
                size: 14,
                bold: true,
              },
              border: {
                top: {
                  style: 'medium',
                  color: '000000',
                },
                bottom: {
                  style: 'medium',
                  color: '000000',
                },
                left: {
                  style: 'medium',
                  color: '000000',
                },
                right: {
                  style: 'medium',
                  color: '000000',
                },
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true,
              },
            },
            combinar: {
              row: inicioTablaResumenPartidas,
              col: columnaTitulos + 1,
            },
          },
        );
        columnaTitulos += 2;
      });

      this.getResumenPartidas.forEach((partida) => {
        tablaResumenPartidas.push(
          {
            value: partida.nombre,
            row: filaDatosTabla,
            col: columnaDatosTabla,
            estilo: {
              font: {
                size: 12,
                bold: false,
              },
              border: {
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true,
              },
            },
            combinar: {
              row: filaDatosTabla,
              col: columnaDatosTabla + 1,
            },
          },
          {
            value: partida.totalImportesPresupuesto,
            row: filaDatosTabla,
            col: columnaDatosTabla + 2,
            estilo: {
              font: {
                size: 12,
                bold: false,
              },
              border: {
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true,
              },
              numberFormat: '#,##0.00',
            },
            combinar: {
              row: filaDatosTabla,
              col: columnaDatosTabla + 3,
            },
          },
          {
            value: partida.totalImportesAcumulados,
            row: filaDatosTabla,
            col: columnaDatosTabla + 4,
            estilo: {
              font: {
                size: 14,
                bold: false,
              },
              border: {
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true,
              },
              numberFormat: '#,##0.00',
            },
            combinar: {
              row: filaDatosTabla,
              col: columnaDatosTabla + 5,
            },
          },
          {
            value: partida.totalImportesAcumuladosMenosImportesPresupuesto,
            row: filaDatosTabla,
            col: columnaDatosTabla + 6,
            estilo: {
              font: {
                size: 14,
                bold: false,
              },
              border: {
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                right: {
                  style: 'thin',
                  color: '000000',
                },
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true,
              },
              numberFormat: '#,##0.00',
            },
            combinar: {
              row: filaDatosTabla,
              col: columnaDatosTabla + 7,
            },
          },
        );
        filaDatosTabla += 1;
      });
      tablaResumenPartidas.push(
        {
          value: 'TOTAL SIN IVA',
          row: filaDatosTabla,
          col: columnaDatosTabla,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: filaDatosTabla,
            col: columnaDatosTabla + 1,
          },
        },
        {
          value: this.$ObjSumar(this.getResumenPartidas, 'totalImportesPresupuesto'),
          row: filaDatosTabla,
          col: columnaDatosTabla + 2,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            numberFormat: '#,##0.00',
          },
          combinar: {
            row: filaDatosTabla,
            col: columnaDatosTabla + 3,
          },
        },
        {
          value: this.$ObjSumar(this.getResumenPartidas, 'totalImportesAcumulados'),
          row: filaDatosTabla,
          col: columnaDatosTabla + 4,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            numberFormat: '#,##0.00',
          },
          combinar: {
            row: filaDatosTabla,
            col: columnaDatosTabla + 5,
          },
        },
        {
          value: this.$ObjSumar(this.getResumenPartidas, 'totalImportesAcumuladosMenosImportesPresupuesto'),
          row: filaDatosTabla,
          col: columnaDatosTabla + 6,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            numberFormat: '#,##0.00',
          },
          combinar: {
            row: filaDatosTabla,
            col: columnaDatosTabla + 7,
          },
        },
      );

      return tablaResumenPartidas;
    },
    crearTablaResmenAnticipos() {
      const tablaResumenAnticipos = [];
      const inicioTablaResumenAnticipos = filaInicioDatos
      + this.catalogoConSubtotalesExcel.length + 10;
      let columnaTitulos = 11; // LET
      tablaResumenAnticipos.push(
        {
          value: 'ANTICIPO OTORGADO',
          row: inicioTablaResumenAnticipos,
          col: columnaTitulos,
          estilo: {
            font: {
              size: 11,
              bold: true,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: this.getImporteAnticipoContrato.importe,
          row: inicioTablaResumenAnticipos + 1,
          col: columnaTitulos,
          estilo: {
            font: {
              size: 12,
              bold: false,
            },
            border: {
              top: {
                style: 'medium',
                color: '000000',
              },
              bottom: {
                style: 'medium',
                color: '000000',
              },
              left: {
                style: 'medium',
                color: '000000',
              },
              right: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
            numberFormat: '#,##0.00',
          },
        },
      );
      columnaTitulos += 1;
      this.getAnticiposEstimaciones.forEach((anticipoEstimacion) => {
        tablaResumenAnticipos.push(
          {
            value: `EST. ${anticipoEstimacion.numEstimacion}`,
            row: inicioTablaResumenAnticipos,
            col: columnaTitulos,
            estilo: {
              font: {
                size: 11,
                bold: true,
              },
              border: {
                top: {
                  style: 'medium',
                  color: '000000',
                },
                bottom: {
                  style: 'medium',
                  color: '000000',
                },
                left: {
                  style: 'medium',
                  color: '000000',
                },
                right: {
                  style: 'medium',
                  color: '000000',
                },
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true,
              },
            },
          },
          {
            value: anticipoEstimacion.importe,
            row: inicioTablaResumenAnticipos + 1,
            col: columnaTitulos,
            estilo: {
              font: {
                size: 12,
                bold: false,
              },
              border: {
                top: {
                  style: 'medium',
                  color: '000000',
                },
                bottom: {
                  style: 'medium',
                  color: '000000',
                },
                left: {
                  style: 'medium',
                  color: '000000',
                },
                right: {
                  style: 'medium',
                  color: '000000',
                },
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true,
              },
              numberFormat: '#,##0.00',
            },
          },
        );
        columnaTitulos += 1;
      });
      return tablaResumenAnticipos;
    },

    crearFirmas() {
      const inicioFirmas = filaInicioDatos
      + this.catalogoConSubtotalesExcel.length
      + this.crearTablaResumenPartidas.length
      + 2;
      // const filaDatosTabla = inicioFirmas + 1;
      const columnaTitulos = 2;
      // const columnaDatosTabla = 2;
      const titulosFirmas = [
        {
          texto: 'FORMULÓ',
          columnaInicial: columnaTitulos,
          anchoCeldas: 2,
          firmas: [
            {
              nombre: this.getRepresentanteLegal,
              subNombre: this.getNombreEmpresa,
            },
          ],
        },
        {
          texto: 'REVISÓ',
          columnaInicial: columnaTitulos + 4,
          anchoCeldas: 10,
          firmas: [
            {
              nombre: this.getContratoSupervisionExterna,
              subNombre: 'SUPERVISIÓN EXTERNA',
            },
            {
              nombre: this.getSupervisor,
              subNombre: 'SUPERVISOR DE OBRA',
            },
            ...this.getFirmasOrdenado,
          ],
        },
      ];
      const tablaFirmas = [];
      // Crear los titulos de la tabla.
      this.setAltoFila({ numero: inicioFirmas, size: 60 });
      titulosFirmas.forEach((titulo) => {
        tablaFirmas.push(
          {
            value: titulo.texto,
            row: inicioFirmas,
            col: titulo.columnaInicial,
            estilo: {
              font: {
                size: 14,
                bold: true,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true,
              },
            },
            combinar: {
              row: inicioFirmas,
              col: titulo.columnaInicial + titulo.anchoCeldas,
            },
          },
        );
        let columnaInicioFirmas = titulo.columnaInicial;
        let numFirma = 0;
        titulo.firmas.forEach((firma) => {
          if (firma.nombre) {
            tablaFirmas.push(
              {
                value: firma.nombre,
                row: numFirma < 3 ? inicioFirmas + 6 : inicioFirmas + 12,
                col: numFirma < 3 ? columnaInicioFirmas : titulo.columnaInicial + 4,
                estilo: {
                  font: {
                    size: 14,
                    bold: true,
                  },
                  alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: true,
                  },
                },
                combinar: {
                  row: numFirma < 3 ? inicioFirmas + 6 : inicioFirmas + 12,
                  col: numFirma < 3 ? columnaInicioFirmas + 2 : titulo.columnaInicial + 6,
                },
              },
              {
                value: firma.subNombre,
                row: numFirma < 3 ? inicioFirmas + 7 : inicioFirmas + 13,
                col: numFirma < 3 ? columnaInicioFirmas : titulo.columnaInicial + 4,
                estilo: {
                  font: {
                    size: 12,
                  },
                  border: {
                    top: {
                      style: 'medium',
                      color: '000000',
                    },
                  },
                  alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: true,
                  },
                },
                combinar: {
                  row: numFirma < 3 ? inicioFirmas + 7 : inicioFirmas + 13,
                  col: numFirma < 3 ? columnaInicioFirmas + 2 : titulo.columnaInicial + 6,
                },
              },
            );
            columnaInicioFirmas += 4;
            numFirma += 1;
          }
        });
      });
      return tablaFirmas;
    },

    crearNombresColumnas() {
      const { columnas } = this;
      // Se agregan los valores de cantidad estimada e importe estimado para cada estimacion.
      for (let k = 0; k < this.estimaciones.length; k += 1) {
        columnas.push(
          `cantidadEstimada${k + 1}`,
          `importeEstimado${k + 1}`,
        );
      }
      return columnas;
    },
    // DATOS DEL ENCABEZADO DEL DOCUMENTO
    crearDatosDocumento() {
      return [
        {
          value: `ACTA DE FINIQUITO DE LOS TRABAJOS RELATIVOS AL CONTRATO DE OBRA PÚBLICA BAJO LA BASE DE PRECIOS UNITARIOS No. ${this.contrato.numero}  Y SUS CONVENIOS`,
          row: 1,
          col: 3,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 1,
            col: 15,
          },
        },
        {
          value: 'I.- Lugar y fecha:',
          row: 2,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 2,
            col: 2,
          },
        },
        // valor de lugar y fecha.
        {
          value: `HERMOSILLO SONORA A ${this.getFechaTexto().toUpperCase()}`,
          row: 2,
          col: 3,
          estilo: {
            font: {
              size: 11,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 2,
            col: 6,
          },
        },
        {
          value: 'I.a  hora:',
          row: 2,
          col: 7,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
            },
          },
        },
        {
          value: '-',
          row: 2,
          col: 8,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
            },
          },
        },
        {
          value: 'Horas',
          row: 2,
          col: 9,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
            },
          },
        },
        {
          value: 'II.- Nombre del Residente:',
          row: 3,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 3,
            col: 2,
          },
        },
        {
          value: this.getSupervisor.toUpperCase(),
          row: 3,
          col: 3,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 3,
            col: 4,
          },
        },
        {
          value: 'II.a  Firma del Residente:',
          row: 3,
          col: 5,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 3,
            col: 6,
          },
        },
        {
          value: ' ',
          row: 3,
          col: 7,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 3,
            col: 8,
          },
        },
        {
          value: 'II.b Nombre del superintendente:',
          row: 3,
          col: 9,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 3,
            col: 11,
          },
        },
        {
          value: this.getSuperintendente.toUpperCase(),
          row: 3,
          col: 12,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 3,
            col: 13,
          },
        },
        {
          value: 'II.c Firma  del superintendente:',
          row: 3,
          col: 14,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 3,
            col: 15,
          },
        },
        {
          value: ' ',
          row: 3,
          col: 16,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 3,
            col: 17,
          },
        },
        {
          value: 'III.- Descripcion de los trabajos:',
          row: 4,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 4,
            col: 2,
          },
        },
        {
          value: this.contrato.meta,
          row: 4,
          col: 3,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 4,
            col: 17,
          },
        },
        {
          value: 'IV.- Importe contractual:',
          row: 5,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 5,
            col: 2,
          },
        },
        {
          value: this.contrato.importe,
          row: 5,
          col: 3,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
            numberFormat: '#,##0.00',
          },
        },
        {
          value: 'MÁS IVA',
          row: 5,
          col: 4,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 5,
            col: 5,
          },
        },
        {
          value: 'IV.a. Importe real ejecutado:',
          row: 5,
          col: 6,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 5,
            col: 8,
          },
        },
        {
          value: '-',
          row: 5,
          col: 9,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 5,
            col: 10,
          },
        },
        {
          value: 'MÁS IVA',
          row: 5,
          col: 11,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
            },
          },
        },
        {
          value: 'V.- Periodo de ejecucion de los trabajos:',
          row: 6,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 6,
            col: 2,
          },
        },
        {
          value: `${this.getFechaTexto(this.contrato.fechaInicio).toUpperCase()} AL ${this.getFechaTexto(this.contrato.fechaTermino).toUpperCase()}`,
          row: 6,
          col: 3,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 6,
            col: 7,
          },
        },
        {
          value: 'V.a.- Periodo de ejecucion real de los trabajos:',
          row: 6,
          col: 8,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 6,
            col: 11,
          },
        },
        {
          value: `${this.getFechaTexto(this.contrato.fechaInicio).toUpperCase()} AL -`,
          row: 6,
          col: 12,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 6,
            col: 17,
          },
        },
        {
          value: 'V.b. Periodo de  ejecucion convenio  No.',
          row: 7,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
            },
          },
          combinar: {
            row: 7,
            col: 2,
          },
        },
        {
          value: '-',
          row: 7,
          col: 3,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 7,
            col: 7,
          },
        },
        {
          value: 'Periodo:',
          row: 7,
          col: 8,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'right',
              vertical: 'bottom',
              wrapText: true,
            },
          },
        },
        {
          value: '-',
          row: 7,
          col: 9,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 7,
            col: 17,
          },
        },
        {
          value: 'VI.- Relación de estimaciones, mediante la cual se indica como se ejecutaron los conceptos y los Gastos Aprobados , se señalan los    conceptos generales que les dieron origen y su saldo resultante , adicionalmente, se incluyen los volumenes reales de obra  ejecutados por concepto de acuerdo al catalogo del Contrato y al catalogo del Convenio.',
          row: 8,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'top',
              wrapText: true,
            },
          },
          combinar: {
            row: 8,
            col: 17,
          },
        },
        {
          value: `VII.- Se hace constar que con fecha ${this.getContratoFianza.fecha}, fue entregada la fianza  No. ${this.getContratoFianza.numero};  de Afiazadora: ${this.getContratoFianza.nombreAfianzadora}; misma que  tendrá vigencia de dos años contados a partir de la fecha que se formalice el Acta de entrega-recepcion, misma que fue el día   [FECHA DE ENTREGA RECEPCION]  y que servirá para responder por el contratista de los defectos que resultaren de la ejecución de los trabajos, de los vicios ocultos y de cualquier otra responsabilidad en que hubiere incurrido en los términos señalados en el contrato respectivo y en la legislación aplicable.`,
          row: 9,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'top',
              wrapText: true,
            },
          },
          combinar: {
            row: 9,
            col: 17,
          },
        },
        {
          value: 'VII.a.- Para el presente Finiquito de Obra, se consideraron aplicar las Penas Convencionales del 1% diario por así convenir a los intereses del Estado y en apego a la Normatividad Vigente.',
          row: 10,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'top',
              wrapText: true,
            },
          },
          combinar: {
            row: 10,
            col: 17,
          },
        },
        {
          value: 'VIII.- Se le notificara al Contratista:',
          row: 11,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 11,
            col: 2,
          },
        },
        {
          value: this.getRepresentanteLegal.toUpperCase(),
          row: 11,
          col: 3,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 11,
            col: 7,
          },
        },
        {
          value: 'EL PRESENTE Finiquito.',
          row: 11,
          col: 8,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 11,
            col: 15,
          },
        },
        {
          value: 'IX.- El contratista declara: que en virtud de haber terminado los trabajos encomendados, solo queda pendiente de pago las estimación número:',
          row: 12,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 12,
            col: 11,
          },
        },
        {
          value: '----',
          row: 12,
          col: 12,
          estilo: {
            font: {
              size: 12,
              bold: true,
            },
            border: {
              bottom: {
                style: 'medium',
                color: '000000',
              },
            },
            alignment: {
              horizontal: 'center',
              vertical: 'bottom',
              wrapText: true,
            },
          },
          combinar: {
            row: 12,
            col: 17,
          },
        },
        {
          value: 'X.- Para el Presente Documento Legal el Contratista, extiende el más amplio Finiquito que en derecho proceda, Renunciando a cualquier acción legal que tenga por objeto reclamar cualquier pago relacionado con el Contrato, ambas partes manifiestan de que no existen otros adeudos. ',
          row: 13,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'top',
              wrapText: true,
            },
          },
          combinar: {
            row: 13,
            col: 17,
          },
        },
        {
          value: `"${this.contrato.meta}"`,
          row: 14,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'top',
              wrapText: true,
            },
          },
          combinar: {
            row: 14,
            col: 17,
          },
        },
      ];
    },

    crearExcelFiniquito() {
      this.setEstiloGlobalTabla({
        filaInicial: filaInicioDatos,
        filaFinal: filaInicioDatos + this.catalogoConSubtotalesExcel.length - 1,
        columnaInicial: 1,
        columnaFinal: 11 + (this.estimaciones.length * 2),
        estilo: {
          border: {
            top: {
              style: 'thin',
              color: '000000',
            },
            bottom: {
              style: 'thin',
              color: '000000',
            },
            left: {
              style: 'thin',
              color: '000000',
            },
            right: {
              style: 'thin',
              color: '000000',
            },
          },
        },
      });
      const catalogoConceptosExcel = this.catalogoConSubtotalesExcel;
      this.setAltoDeFilas(catalogoConceptosExcel);
      const datosDocumento = this.crearDatosDocumento
        .concat(this.crearTablaResumenEstimaciones)
        .concat(this.crearTablaResumenPartidas)
        .concat(this.crearTablaResmenAnticipos)
        .concat(this.crearFirmas);
      const dataHeaders = this.crearHeaders;
      // Se agregan totales para cantidad e importe a nombres de columnas.
      const nombreDeColumnas = [...this.crearNombresColumnas, 'totalCantidad', 'totalImporte', 'diferenciaCantidad', 'diferenciaImporte'];

      const data = {
        excelData: {
          configuracion: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            logos: [...this.logoDocumento],
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            estilo: this.estiloBody,
            filaInicio: filaInicioDatos,
            data: [...catalogoConceptosExcel],
          },
        },
      };
      return data;
    },
  },

};
</script>

<style>

</style>
